import { render } from "./FindInImages.vue?vue&type=template&id=6087af27&scoped=true&ts=true"
import script from "./FindInImages.vue?vue&type=script&lang=ts"
export * from "./FindInImages.vue?vue&type=script&lang=ts"

import "./FindInImages.vue?vue&type=style&index=0&id=6087af27&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6087af27"]])

export default __exports__